import { Cloud } from '@webapp/common/assets/icons';
import { fileSize } from '@webapp/common/lib/ui';

import css from './capacity.css';

export const Capacity: FC<{
    size: number;
}> = ({ size }) => {
    const [sz, unit] = fileSize(size, true);
    return (
        <div className={css.graph}>
            <div className={css.size}>
                <Cloud />
                <div className={css.num}>{sz}</div>
                <div className={css.unit}>{unit}</div>
            </div>
        </div>
    );
};
